function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.875 3.9375H10.125C8.5717 3.9375 7.3125 5.1967 7.3125 6.75V29.25C7.3125 30.8033 8.5717 32.0625 10.125 32.0625H25.875C27.4283 32.0625 28.6875 30.8033 28.6875 29.25V6.75C28.6875 5.1967 27.4283 3.9375 25.875 3.9375Z",
  fill: "#E6FAF8",
  stroke: "#0D9488",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M23.0625 3.9375L28.6875 9.5625H23.0625V3.9375Z",
  fill: "#0D9488"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0625 3.9375V9.5625H28.6875",
  stroke: "#0D9488",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M14.625 14.0625H12.375C11.7537 14.0625 11.25 14.5662 11.25 15.1875V24.1875C11.25 24.8088 11.7537 25.3125 12.375 25.3125H14.625C15.2463 25.3125 15.75 24.8088 15.75 24.1875V15.1875C15.75 14.5662 15.2463 14.0625 14.625 14.0625Z",
  fill: "#0D9488"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M20.25 16.875H18C17.3787 16.875 16.875 17.3787 16.875 18V24.1875C16.875 24.8088 17.3787 25.3125 18 25.3125H20.25C20.8713 25.3125 21.375 24.8088 21.375 24.1875V18C21.375 17.3787 20.8713 16.875 20.25 16.875Z",
  fill: "#0D9488"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M24.75 12.9375C24.75 12.3162 24.2463 11.8125 23.625 11.8125C23.0037 11.8125 22.5 12.3162 22.5 12.9375V24.1875C22.5 24.8088 23.0037 25.3125 23.625 25.3125C24.2463 25.3125 24.75 24.8088 24.75 24.1875V12.9375Z",
  fill: "#0D9488"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M23.9062 10.6875H12.0938C11.6278 10.6875 11.25 11.0653 11.25 11.5312C11.25 11.9972 11.6278 12.375 12.0938 12.375H23.9062C24.3722 12.375 24.75 11.9972 24.75 11.5312C24.75 11.0653 24.3722 10.6875 23.9062 10.6875Z",
  fill: "#0D9488"
});

function SvgIconCustomReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomReport);
export default __webpack_public_path__ + "static/media/icon_custom_report.5e946c6e.svg";
export { ForwardRef as ReactComponent };